<template>
	<!-- 电子智能秤 -->
	<div id="equipment-xxgsp">
		<!-- 轮播组件 -->
		<Carousel :picList="picList">
            <template slot="imgTitle">
                <div class="img-title">
                    <div class="img-title-txt" data-am-scrollspy="{animation: 'slide-right', repeat: false}">
                        <h1 data-am-scrollspy="{animation: 'scale-up', repeat: false}">信息公示</h1>
                        <div>
                            <p data-am-scrollspy="{animation: 'slide-top', delay: 200, repeat: false}">展现形式多样</p>
                            <p data-am-scrollspy="{animation: 'slide-top', delay: 400, repeat: false}">展示内容丰富</p>
                        </div>
                    </div>
                </div> 
            </template>
        </Carousel>

		<div class="parameter-table">
			<div class="container">
				<!-- 设备参数表组件 -->
				<parameter-table :parameter="config"></parameter-table>
			</div>
		</div>

        <div class="block part">
            <div class="container">
				<h1 data-am-scrollspy="{animation: 'slide-top', repeat: false}">产品价值</h1>
				<ul class="show-list flex bCenter">
                    <li 
                        v-for="(item, index) in config.part" 
                        :key="index"
                        :data-am-scrollspy="`{animation: 'scale-up', delay: ${500+(index+1)*200}, repeat: false}`">
						<div class="img-rect flex middle center">
							<img :src="item.cover" alt="">
						</div>
						<div class="content">
							<h3>{{ item.title }}</h3>
							<p>{{ item.disc }}</p>
						</div>
					</li>
                </ul>
			</div>
        </div>

        <div class="block part" style="background-color: #f2f4f5;padding:0;">
            <div class="recommended_general container">
                <h1 class="p1">推荐硬件</h1>
                <div v-if="!$utils.isArrayEmpty(recommSHList)" class="recommended_general_content">
                    <router-link v-for="(item,index) in recommSHList" :to="item.routeUrl||''" :key="index" class="recommended_general_item">
                        <i v-if="$utils.isNoNullAll(item.icon)" :class="item.icon"></i>
                        <span class="text">{{item.name}}</span>
                    </router-link>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import generalConfig from "config/general.config.js";
import $ from 'jquery'
import Carousel from 'components/Carousel/Carousel.vue';
import parameterTable from 'components/ParameterTable';

import config from './config';
import metaInfoUtils from 'config/metaInfo.config.js';

export default {
    metaInfo: metaInfoUtils.currentMetaInfo('/equipment/xxgsp'),
	components: {
		Carousel,
		parameterTable
	},
	data() {
		return {
            recommSHList:generalConfig.recommSHList,//推荐智能硬件
			config,
			picList: [
				{
					imgUrl: require('@/assets/images/equipment/xxgsp/banner_01.png'),
				}
			],
		}
    },
    mounted(){
        require ("utils/js/amazeui.js");
		// require ("utils/css/amazeui.css");
        $('[data-am-scrollspy]').scrollspy();
    },
	methods: {

	}
}
</script>

<style lang="less" scoped>
@import '~utils/css/amazeui.css';
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
#equipment-xxgsp {

    .img-title {
        position: absolute;
        top: 0px;
        right: 0;
        width: 100%;
        height: 100%;
        font-size: 70px;
        >div:first-child {
            position: absolute;
            top: 110px;
            right: 342px;
            margin-left: 20px;
            width: 600px;
            h1 {
                font-size: 60px;
                // font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                margin-bottom: 56px;
            }
            p {
                text-align: center;
                font-size: 18px;
                // font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 40px;
            }
        }
    }
    
	.container {
		width: @defalutContentWidth;
		margin: 0 auto;
	}
	.parameter-table {
		background: #F2F4F5;
    }
    
    .block {
        padding-top: 51px;
        .container {
			width: @defalutContentWidth;
            margin: 0 auto;
            >h1 {
                font-size: 60px;
                // font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 500;
                text-align: center;
                color: #333333;
                line-height: 60px;
                margin-bottom:30px;
                +p {
                    font-size: 24px;
                    // font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                    font-weight: 400;
                    text-align: center;
                    color: #333333;
                    line-height: 40px;
                }
            }
            .show-list {
                li {
                    background: #fff;
					width: 48.5%;
                    overflow: hidden;
                    transition: all .6s;
                    &:hover {
                        // box-shadow: 0px 8px 8px 0px rgba(0,0,0,0.16); 
                        // transform: translate(-2px, -2px);
                        .img-rect img {
                            transform: scale(1.1);
                        }
                    }
                    .img-rect {
                        overflow: hidden;
                        img {
                            width: 100%;
                            vertical-align: middle;
                            height: 350px;
                            transition: all .6s;
                        }
                        &:hover {
                        }
                    }
                    .content {
                        padding: 38px 24px  32px;
                        h3 {
                            font-size: 30px;
                            // font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                            font-weight: 500;
                            color: #333333;
                            margin-bottom: 19px;
                        }
                        p {
                            font-size: 18px;
                            // font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                            font-weight: 400;
                            color: #333333;
                            line-height: 27px;
                        }
                    }
                }
            }
        }
    }
    
    .part {
        padding-bottom: 82px;
        h1 {
            margin-top: 31px;
            margin-bottom: 69px !important;
        }
        ul {
            margin-bottom: 54px;
        }
    }
}
</style>
